import {object, string, number, array} from 'yup';

export const addDiagnosis = object({
    diagnosis: string()
    .min(10, 'diagnosis and observation is too short')
    .max(200, 'diagnosis and observation length exceeded')
    // .required('diagnosis is required'),
})